import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  DirectDepositBanner,
} from '../../myAccount/reimbursement/directDepositBanner';

import check from '../../../assets/billingPayments/cash-payment-sign.svg';

import styles from './Reimbursement.module.css';
import { MARKETING_CHANNEL_ID } from '../../../theme/theme.constants';

export const Check = ({
  addressCheck = '',
  isRedirectAvailable = false,
  marketChannelId = 0,
  onReimbursementMethod = null,
}) => {
  const { t } = useTranslation('insurance');

  return (
    <div className={styles.reimbursementMethodCard}>
      <div className={styles.reimbursementMethodRow}>
        <img alt="check" src={check} />

        <span>{t('checkSent', { addressCheck })}</span>
      </div>

      {marketChannelId === MARKETING_CHANNEL_ID.figo && (
        <DirectDepositBanner
          containerClassName={styles.noMargin}
          onSetupClick={onReimbursementMethod}
          validPolicyStatus={isRedirectAvailable}
        />
      )}
    </div>
  );
};
